export default "__VITE_ASSET__DxXAlOTm__"